var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5603 23.0003V20.5559C19.5603 19.2593 19.0453 18.0158 18.1284 17.0989C17.2116 16.1821 15.9681 15.667 14.6714 15.667H7.33811C6.04149 15.667 4.79799 16.1821 3.88114 17.0989C2.9643 18.0158 2.44922 19.2593 2.44922 20.5559V23.0003",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0041 10.7778C13.7042 10.7778 15.893 8.58895 15.893 5.88889C15.893 3.18883 13.7042 1 11.0041 1C8.30406 1 6.11523 3.18883 6.11523 5.88889C6.11523 8.58895 8.30406 10.7778 11.0041 10.7778Z",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeActive);
export default __webpack_public_path__ + "static/media/employee_active.988ed8d4bc3ef4c29fbc752bd6dbc2be.svg";
export { ForwardRef as ReactComponent };